module.exports = __webpack_public_path__ + "static/media/13(3).d835946c.jpg";